import { Transcripts } from './Transcripts';

export function LegacyTranscripts() {
  return <Transcripts view="LEGACY" />;
}
